/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

/* eslint-disable no-console */
import { iconSvgStrings } from './assets/icons.js';

// Utility function to sanitize SVG content
function sanitizeSvg(svgString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(svgString, 'image/svg+xml');
    const isValidSvg = doc.documentElement.tagName.toLowerCase() === 'svg';
    
    // Further checks can be added here (e.g., ensuring no script tags)
    return isValidSvg ? doc.documentElement.outerHTML : '';
}

document.addEventListener('DOMContentLoaded', function () {
    const iconElements = document.querySelectorAll('.focus-area__icon');

    iconElements.forEach(function (iconElement) {
        const iconName = iconElement.getAttribute('data-icon');

        if (iconName && iconSvgStrings[iconName]) {
            // Sanitize the SVG string before inserting it into the DOM
            const sanitizedSvg = sanitizeSvg(iconSvgStrings[iconName]);

            if (sanitizedSvg) {
                iconElement.innerHTML = sanitizedSvg;  // Inject sanitized SVG
            } else {
                console.warn(`Invalid or unsafe SVG for icon: ${iconName}`);
            }
        }
    });
});
/* eslint-enable no-console */
